import { render } from "./discount-create.vue?vue&type=template&id=541f458a"
import script from "./discount-create.vue?vue&type=script&lang=js"
export * from "./discount-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__